export default __webpack_public_path__ + "static/shareholder-mettings-40c28a4884454135300dd81c1ed6b170.png";